import {
  StyledArticleCard,
  StyledDate,
  StyledImage,
  StyledInfo,
  StyledTitle,
} from "./styles";

import { formatDate } from "@utils/dateFormat";
import { StaticImageData } from "next/image";
import React, { FC, memo } from "react";

interface ArticleCardProps {
  className?: string;
  style?: React.CSSProperties;

  title: string;
  date: string;
  image: string | StaticImageData;
}

const _ArticleCard: FC<ArticleCardProps> = (props) => {
  const { title, image, date, ...restProps } = props;

  const dateStr = formatDate(date, "DD MMMM YYYY - HH:MM");

  return (
    <StyledArticleCard {...restProps}>
      <StyledImage src={image} alt={title} title={`изображение - ${title}`} />

      <StyledInfo>
        <StyledTitle>{title}</StyledTitle>
        <StyledDate>{dateStr}</StyledDate>
      </StyledInfo>
    </StyledArticleCard>
  );
};

export const ArticleCard = memo(_ArticleCard);
